import { AttributeValue, Total } from '@ui/interfaces'
import { readableBytes, readableNumber } from '@ui/lib/utils'

interface IProps {
  selectedKey: string
  selectedValue: AttributeValue
  total: Total
}

export const Tooltip = (props: IProps) => {
  return (
    <div>
      <p className="font-semibold text-gray-900">{props.selectedKey}</p>
      <p className="text-sm">
        {props.selectedValue.count > 0 ? `${props.selectedValue.value || '<empty>'}` : '<All values>'}
      </p>
      <div className="text-xs font-normal text-gray-500">
        {props.selectedValue.count > 0 ? (
          <p>
            {readableNumber(props.selectedValue.count)} events ({props.selectedValue.ratio.toFixed(1)}%) |{' '}
            {readableBytes(props.selectedValue.size)}
          </p>
        ) : (
          <p>
            {readableNumber(props.total.count)} events | {readableBytes(props.total.size)}
          </p>
        )}
      </div>
    </div>
  )
}
